import React from 'react';
import LandingNavigation from '../landing/LandingNavigation';
import LandingFooter from '../LandingFooter';
import SEO from '../SEO';
import './portalTheme.css';

export const navigatePortal = (path) => {
  window.history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
  window.scrollTo(0, 0);
};

export default function PortalFrame({ children, title, description, onBack, onLogin, onRegister, navigateTo }) {
  const navigate = navigateTo || navigatePortal;
  return (
    <div className="lexa-portal min-h-screen flex flex-col">
      {title && <SEO title={title} description={description} />}
      <LandingNavigation onLogin={onLogin} onRegister={onRegister} navigateTo={navigate} onHome={onBack} productTarget="/features" />
      <main className="lexa-portal-content flex-1">{children}</main>
      <LandingFooter navigateTo={navigate} />
    </div>
  );
}
